import nextGenDiagnosticsIcon from "../../assets/nextgen-diagnostics-icon.png";

export interface NextGenBrandIconProps {
  size?: number;
  className?: string;
  monochrome?: "light" | "dark";
}

/**
 * The official NextGen Diagnostics mark supplied in the deployment's brand
 * kit. The transparent source is kept at print quality and Vite emits an
 * optimized, fingerprinted asset for each application.
 */
export function NextGenBrandIcon({
  size = 40,
  className,
  monochrome,
}: NextGenBrandIconProps) {
  return (
    <img
      aria-hidden="true"
      alt="brand icon for NextGen Diagnostics"
      className={
        className
          ? `evolys-nextgen-brand-icon ${className}`
          : "evolys-nextgen-brand-icon"
      }
      height={size}
      src={nextGenDiagnosticsIcon}
      style={{
        objectFit: "contain",
        filter:
          monochrome === "light"
            ? "brightness(0) invert(1)"
            : monochrome === "dark"
              ? "brightness(0)"
              : undefined,
      }}
      width={size}
    />
  );
}
